/**
 * Narrowed view of the engine KPI types + metrics responses. Mirrors
 * `packages/types/src/kpi-{type,metric}.ts` minus fields the UI doesn't
 * currently render. The list responses come back as
 * `Record<string, unknown>` from `useKpiTypes` / `useKpiMetrics`; the
 * `as*` helpers narrow at the page boundary.
 */
export interface KpiType {
  id: number;
  name: string;
  color: string;
  icon: string;
  createdAt?: string;
}

export interface KpiMetric {
  id: number;
  displayName: string;
  internalName?: string;
  color: string;
  icon: string;
  kpiTypeId: number | null;
}

export function asKpiType(row: Record<string, unknown>): KpiType {
  return {
    id: typeof row.id === 'number' ? row.id : 0,
    name: typeof row.name === 'string' ? row.name : '',
    color: typeof row.color === 'string' ? row.color : '#94a3b8',
    icon: typeof row.icon === 'string' ? row.icon : '',
    createdAt: typeof row.createdAt === 'string' ? row.createdAt : undefined,
  };
}

export function asKpiMetric(row: Record<string, unknown>): KpiMetric {
  return {
    id: typeof row.id === 'number' ? row.id : 0,
    displayName: typeof row.displayName === 'string' ? row.displayName : '',
    internalName: typeof row.internalName === 'string' ? row.internalName : undefined,
    color: typeof row.color === 'string' ? row.color : '#94a3b8',
    icon: typeof row.icon === 'string' ? row.icon : '',
    kpiTypeId:
      typeof row.kpiTypeId === 'number'
        ? row.kpiTypeId
        : row.kpiTypeId == null
          ? null
          : Number(row.kpiTypeId),
  };
}
